import styled from 'styled-components';
import sharedStyles from '../styles';

const SidebarRow = styled.div`
  margin-bottom: ${sharedStyles.spacing['spacing-1xs']};

  a {
    text-decoration: none;
    cursor: pointer;
    font-size: inherit;
    font-weight: inherit;
    color: ${({ theme }) => theme.colors.linkHover};

    &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
      text-decoration: underline;
    }
  }
`;

export default SidebarRow;
